import styled, { css, keyframes } from 'styled-components';
import { imageUrl } from '../services/helpers';

export const COIN_SIZE = 88;

const breathe = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 45;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, .35);
`;

export const Tray = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-radius: 18px;
  background: rgba(16, 38, 28, .92);
  box-shadow: 0 10px 30px rgba(0, 0, 0, .5);
  color: var(--ink);
  text-align: center;
`;

export const Label = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

export const Coins = styled.div`
  display: flex;
  gap: 14px;
  padding-top: 40px;
`;

export const CoinSpot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: ${COIN_SIZE}px;
  font-size: 13px;
  font-weight: 700;
  color: var(--accent);
`;

/** The coin to tap. What moves is inside it (Spinner). */
export const Coin = styled.button`
  width: ${COIN_SIZE}px;
  height: ${COIN_SIZE}px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  ${props => props.$waiting && css`animation: ${breathe} 1.2s ease-in-out infinite;`}
`;

/**
 * The two faces, heads over tails. The toss turns the coin in 2D (squashing it to its edge and back) and shows
 * whichever face is up: 3D turning with hidden backs draws the wrong face in WebKit. Heads is the Chansey coin from
 * the rulebook.
 */
export const Spinner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const face = css`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  box-shadow: inset 0 0 0 3px rgba(255, 255, 255, .35), 0 4px 10px rgba(0, 0, 0, .45);
`;

export const Heads = styled.span`
  ${face}
  z-index: 1;
  background: #b9bcbf url(${imageUrl('/rules/version-2/pictures/chansey-coin.webp')}) center / 118% no-repeat;
`;

export const Tails = styled.span`
  ${face}
  background: radial-gradient(circle at 35% 30%, #f2f3f4, #a7abaf 60%, #7d8185);

  &::after {
    content: '';
    position: absolute;
    inset: 14%;
    border-radius: 50%;
    border: 3px solid rgba(80, 84, 88, .45);
  }
`;

export const Hint = styled.div`
  font-size: 14px;
  color: var(--muted);
`;
